import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { UserData } from 'interfaces/UserData.interface';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  cardPadding: {
    padding: 0,
  },
  infoText: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  nameText: {
    color: '#36899f',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  timeText: {
    color: '#c1c1c1',
    fontSize: '14px',
  },
}));

interface listsProps {
  user: UserData;
  time: string;
  image: string;
  type: string;
  message: string;
}
const Lists: React.FC<listsProps> = ({ user, time, type, message, image }) => {
  const user0 = require('assets/Profile/buku_default_avatar.png');
  const img0 = require('assets/img0.png');

  const classes = useStyles();

  return (
    <Card
      // onClick={showSendMessage}
      sx={{
        backgroundColor: 'transparent',
        paddingBottom: '24px',
        boxShadow: 'none',
      }}
    >
      <CardContent
        style={{
          padding: 'unset',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <CardContent
          style={{ padding: 'unset' }}
          sx={{
            display: 'flex',
            gap: '20px',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <Link to={`/profile/${user.username}/feed`}>
            <CardMedia
              component="img"
              sx={{
                borderRadius: '25px',
                width: '41px',
                height: '39px',
              }}
              image={user.avatar || user0}
              alt="user image"
            />
          </Link>
          <CardContent style={{ padding: 'unset' }}>
            <Link to={`/profile/${user.username}/feed`} className="a-no-style">
              <Typography component={'span'} className={classes.nameText}>
                {user.username}&nbsp;
              </Typography>
              <Typography component={'span'} className={classes.infoText}>
                {message}
              </Typography>
              <Typography className={classes.timeText}>{time}</Typography>
            </Link>
          </CardContent>
        </CardContent>
        <CardContent style={{ padding: 'unset' }}>
          {type === 'first' ? (
            <Link to={`/profile/${user.username}/feed`}>
              <CardMedia
                component="img"
                sx={{
                  padding: 'unset',
                  borderRadius: '10px',
                  width: '45px',
                  height: '43px',
                  marginLeft: '1rem',
                  objectFit: 'cover',
                }}
                image={image || img0}
                src={image || img0}
              />
            </Link>
          ) : (
            <></>
          )}
        </CardContent>
      </CardContent>
      {/* <Collapse in={show} timeout="auto" unmountOnExit>
        <CardContent
          style={{ padding: "unset", paddingTop: "12px", paddingLeft: "60px" }}
        >
          <div onClick={() => history("/dmessage")}>
            <ColorButton text={"Send a welcome message?"} color={"yellow"} />
          </div>
        </CardContent>
      </Collapse> */}
    </Card>
  );
};

Lists.propTypes = {};

export default Lists;
